// src/pages/HomePage.tsx
import React from 'react';
import { Typography, Container, Grid, Card, CardActionArea, CardContent } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { menuConfig } from '../config/menuConfig';

const HomePage: React.FC = () => {
    const { t } = useTranslation();

    return (
        <Container maxWidth="lg" sx={{ textAlign: 'center' }}>
            {/* 
              - Updated to use i18n key 'welcome_title' for a more professional and brand-focused heading.
            */}
            <Typography variant="h3" component="h1" gutterBottom>
                {t('welcome_title', { ns: 'common' })}
            </Typography>
            {/* 
              - Updated to use i18n key 'welcome_description' for a modern, engaging description.
            */}
            <Typography variant="h6" color="text.secondary" sx={{ mb: 6 }}>
                {t('welcome_description', { ns: 'common' })}
            </Typography>

            <Grid container spacing={4} justifyContent="center">
                {menuConfig.map((category) => (
                    <Grid item xs={12} sm={6} md={4} key={category.id} {...{} as any}>
                        {/* 
              - Set a minHeight to ensure all cards have the same height.
              - Use flexbox to structure the content vertically.
            */}
                        <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column', minHeight: '280px' }}>
                            {/* 
                - Set flexGrow to 1 so the clickable area fills the entire card.
              */}
                            <CardActionArea
                                component={RouterLink}
                                to={category.route}
                                sx={{
                                    flexGrow: 1,
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'center',
                                    p: 3
                                }}
                            >
                                {/* 
                  - Changed icon color to 'text.primary' for a neutral, professional look.
                  - This color adapts to light/dark themes automatically (black/white).
                */}
                                <category.icon sx={{ fontSize: 60, color: 'text.primary', mb: 2 }} />
                                <CardContent sx={{ flexGrow: 0 }}>
                                    <Typography variant="h5" component="h2" gutterBottom>
                                        {t(category.nameKey, { ns: 'tools' })}
                                    </Typography>
                                    <Typography variant="body2" color="text.secondary">
                                        {t(category.descKey, { ns: 'tools' })}
                                    </Typography>
                                </CardContent>
                            </CardActionArea>
                        </Card>
                    </Grid>
                ))}
            </Grid>
        </Container>
    );
};

export default HomePage;